import { WrappedDecimal } from "../basic";
export class StakingRewardRate extends WrappedDecimal {
    constructor(wrapped) {
        super(wrapped);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isCompatibleWith(that) {
        return false;
    }
    wrap(value) {
        return new StakingRewardRate(value);
    }
}
//# sourceMappingURL=StakingRewardRate.js.map